import { axios } from '@/lib/httpClient'

import { Review, ReviewResponse } from '../types'

export const postReview = async (review: Review) => {
    const res = await axios.post<ReviewResponse>('/order/review', review)
    return res.data
}
